import { _post, _get, _delete } from "./Axios";

export default class KpiPeriodeApi {
  static get(id = null) {
    if (id == null) {
      return _get("kpi/periode");
    } else {
      return _get("kpi/periode/" + id);
    }
  }
  static getbyparam(parameters) {
    let params = [];
    Object.keys(parameters).forEach((element) => {
      params.push(element + "=" + parameters[element]);
    });
    params = params.join("&");
    return _get("kpi/periode?" + params);
  }
  static post(data) {
    return _post("kpi/periode", data);
  }
  static update(id, data) {
    return _post("kpi/periode/" + id, data);
  }
  static delete(id) {
    return _delete("kpi/periode/" + id);
  }
}
